import { axios2 } from '@/lib/axios';
import { useQuery } from 'react-query';

export const getAcceptedRequest = () => {
  return axios2.get('/customer-api/my-accepted-lawyer-request');
};

export const useGetAcceptedRequestLawyer = () => {
  return useQuery({
    queryKey: ['get-accepted-request-lawyer'],
    queryFn: () => getAcceptedRequest(),
  });
};

export const getPropertyLawyerReq = () => {
  return axios2.get('/customer-api/my-lawyer-send-received-request?request_type=sent');
};

export const useGetPropertyLawyerReq = () => {
  return useQuery({
    queryKey: ['get-property-lawyer-req'],
    queryFn: () => getPropertyLawyerReq(),
  });
};

